import { Anchor } from './Anchor';
import { AnyLink } from './AnyLink';
import { BrokenImage } from './BrokenImage';
import { DeviceDetector } from './DeviceDetector';
import { Dismissable } from './Dismissable';
import { DrawerToggle } from './DrawerToggle';
import { FileInput } from './FileInput';
import { FormValidator } from './FormValidator';
import { defaultFrontierConfig } from './FrontierConfig';
import { ImageGallery } from './ImageGallery';
import { LazyImage } from './LazyImage';
import { RevealOnScroll } from './RevealOnScroll';
import { ScrollDetector } from './ScrollDetector';
import { ScrollProgress } from './ScrollProgress';
import { SmoothScroll } from './SmoothScroll';
import { SwipeDetector } from './SwipeDetector';
import { Toggle } from './Toggle';
import { Tooltipper } from './Tooltip';
import { WindowOpener } from './WindowOpener';
export * from './Anchor';
export * from './BrokenImage';
export * from './common/Store';
export * from './Dismissable';
export * from './DrawerToggle';
export * from './Toggle';
export * from './FileInput';
export * from './FormValidator';
export * from './FrontierConfig';
export * from './FrontierPlugin';
export * from './LazyImage';
export * from './SmoothScroll';
export * from './WindowOpener';
export * from './RevealOnScroll';
export * from './ScrollProgress';
export * from './ScrollDetector';
const createIf = (cond, create) => {
    return cond ? create() : undefined;
};
const resolveConfig = (config) => {
    return (config === true || config === false)
        ? {}
        : config;
};
class FrontierLoader {
    constructor(win = window) {
        this.win = win;
    }
    load(userConfig = {}) {
        const config = Object.assign({}, defaultFrontierConfig, userConfig);
        const dismissable = createIf(config.dismissable, () => new Dismissable(this.win));
        const brokenImages = createIf(config.brokenImage, () => new BrokenImage(this.win));
        const lazyImage = createIf(config.lazyImage, () => new LazyImage(this.win));
        const toggle = createIf(config.toggle, () => new Toggle(this.win));
        const drawerToggle = createIf(config.drawerToggle, () => new DrawerToggle(this.win));
        const formValidator = createIf(config.formValidator, () => new FormValidator(this.win));
        const anchor = createIf(config.anchor, () => new Anchor(this.win, resolveConfig(config.anchor)));
        const fileInput = createIf(config.fileInput, () => new FileInput(this.win));
        const smoothScroll = createIf(config.smoothScroll, () => new SmoothScroll(this.win));
        const imageGallery = createIf(config.imageGallery, () => new ImageGallery(this.win));
        const deviceDetector = createIf(config.deviceDetector, () => new DeviceDetector(this.win));
        const tooltipper = createIf(config.tooltip, () => new Tooltipper(this.win, resolveConfig(config.tooltip)));
        const windowOpener = createIf(config.windowOpener, () => new WindowOpener(this.win));
        const anyLink = createIf(config.anyLink, () => new AnyLink(this.win));
        const swipeDetector = createIf(config.swipeDetector, () => new SwipeDetector(this.win));
        const scrollDetector = createIf(config.scrollDetector, () => new ScrollDetector(this.win));
        const revealOnScroll = createIf(config.revealOnScroll, () => new RevealOnScroll(this.win));
        const scrollProgress = createIf(config.scrollProgress, () => new ScrollProgress(this.win));
        return new Frontier(brokenImages, lazyImage, toggle, drawerToggle, formValidator, anchor, dismissable, fileInput, smoothScroll, imageGallery, deviceDetector, tooltipper, windowOpener, anyLink, swipeDetector, scrollDetector, revealOnScroll, scrollProgress);
    }
    loadAndActivate(config = {}) {
        return this.load(config).activate();
    }
}
export class Frontier {
    constructor(brokenImage, lazyImage, toggle, drawerToggle, formValidator, anchor, dismissable, fileInput, smoothScroll, imageGallery, deviceDetector, tooltip, windowOpener, anyLink, swipeDetector, scrollDetector, revealOnScroll, scrollProgress) {
        this.brokenImage = brokenImage;
        this.lazyImage = lazyImage;
        this.toggle = toggle;
        this.drawerToggle = drawerToggle;
        this.formValidator = formValidator;
        this.anchor = anchor;
        this.dismissable = dismissable;
        this.fileInput = fileInput;
        this.smoothScroll = smoothScroll;
        this.imageGallery = imageGallery;
        this.deviceDetector = deviceDetector;
        this.tooltip = tooltip;
        this.windowOpener = windowOpener;
        this.anyLink = anyLink;
        this.swipeDetector = swipeDetector;
        this.scrollDetector = scrollDetector;
        this.revealOnScroll = revealOnScroll;
        this.scrollProgress = scrollProgress;
    }
    static load(config = {}, win = window) {
        return new FrontierLoader(win)
            .load(config);
    }
    static loadAndActivate(config = {}, win = window) {
        return new FrontierLoader(win)
            .loadAndActivate(config);
    }
    activate() {
        return Promise.all(this.getActivePlugins().map(p => this.activatePlugin(p))).then(() => this);
    }
    activatePlugin(plugin) {
        return Promise.resolve()
            .then(() => plugin.activate());
    }
    getActivePlugins() {
        return [
            this.brokenImage,
            this.lazyImage,
            this.toggle,
            this.drawerToggle,
            this.formValidator,
            this.anchor,
            this.dismissable,
            this.fileInput,
            this.smoothScroll,
            this.imageGallery,
            this.deviceDetector,
            this.tooltip,
            this.windowOpener,
            this.anyLink,
            this.swipeDetector,
            this.scrollDetector,
            this.revealOnScroll,
            this.scrollProgress
        ].filter(component => !!component);
    }
}
